import { render, staticRenderFns } from "./Search_Uzak.vue?vue&type=template&id=0f798b90&"
import script from "./Search_Uzak.vue?vue&type=script&lang=js&"
export * from "./Search_Uzak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports